/**
 *
 * @module entry
 * @desc {SDK.Identity} entry point.
 *
 */

import Adobe from './adobe/entry';
import Bam from './bam/entry';

/**
 *
 * @typedef SDK.Identity
 * @type {Object}
 *
 * @property {Adobe} Adobe
 * @property {Bam} Bam
 *
 */

/**
 *
 * @type {SDK.Identity}
 *
 */
export default {

    Adobe,
    Bam

};



// WEBPACK FOOTER //
// ./src/identity/entry.js